import { useLayoutEffect, useRef, useCallback } from 'react';

export const useAutoFontSize = () => {
  const items = useRef<
    Array<{
      el: HTMLElement;
      min: number;
      max: number;
    }>
  >([]);

  const register = useCallback(
    (min: number, max: number) => (el: HTMLElement | null) => {
      if (!el) return;
      items.current.push({ el, min, max });
    },
    []
  );

  const recalc = () => {
    items.current.forEach(({ el, min, max }) => {
      const parentWidth = el.parentElement?.clientWidth || 0;
      if (!parentWidth) return;

      let size = max;
      el.style.fontSize = size + 'px';

      while (el.scrollWidth > parentWidth && size > min) {
        size -= 1;
        el.style.fontSize = size + 'px';
      }
    });
  };

  useLayoutEffect(() => {
    recalc();
    window.addEventListener('resize', recalc);
    return () => window.removeEventListener('resize', recalc);
  }, []);

  return { register, recalc };
};
